import { useLabInvoiceAttachmentViewUrl } from "@api/hooks";

// Append a fragment so the browser's built-in PDF viewer opens fitted to the
// container width with no side nav panel. Avoids the nested horizontal
// scrollbar inside the iframe when the page is wider than our column.
function withViewerHints(url) {
  if (!url) return url;
  const hint = "view=FitH&toolbar=1&navpanes=0";
  return url.includes("#") ? `${url}&${hint}` : `${url}#${hint}`;
}

// `useViewUrl` lets other stored PDFs (e.g. Invisalign invoices) reuse this
// frame: any hook taking an id and returning `{ url, filename }`.
export default function LabInvoicePdfFrame({
  attachmentId,
  title = "Lab invoice PDF",
  className = "",
  useViewUrl = useLabInvoiceAttachmentViewUrl,
}) {
  const { data, isLoading, isError, error } = useViewUrl(attachmentId);

  if (isLoading) {
    return (
      <div
        className={`flex h-full min-h-96 items-center justify-center text-sm text-palette-gray-secondary ${className}`}
      >
        Loading PDF...
      </div>
    );
  }

  if (isError) {
    const message = error?.response?.data?.detail || "Unable to load PDF.";
    return (
      <div
        className={`flex h-full min-h-96 items-center justify-center text-sm text-palette-rose-badge ${className}`}
      >
        {message}
      </div>
    );
  }

  if (!data?.url) {
    return (
      <div
        className={`flex h-full min-h-96 items-center justify-center text-sm text-palette-gray-secondary ${className}`}
      >
        PDF unavailable.
      </div>
    );
  }

  return (
    <iframe
      key={data.url}
      src={withViewerHints(data.url)}
      title={data.filename || title}
      className={`block h-full w-full border-0 ${className}`}
    />
  );
}
